const AWS_S3_STORAGE_CLASS = 'STANDARD_IA';
const AZURE_BLOB_TYPE = 'BlockBlob';

const isAzurePresignedUrl = (signedUrl: string) =>
  signedUrl.includes('blob.core.windows.net') ||
  (/[?&]sig=/i.test(signedUrl) && !/[?&]X-Amz-/i.test(signedUrl));

export const getSignedUrlUploadHeaders = (signedUrl: string) => {
  const headers: Record<string, string> = {
    'Content-Type': 'multipart/form-data',
  };

  if (isAzurePresignedUrl(signedUrl)) {
    headers['x-ms-blob-type'] = AZURE_BLOB_TYPE;
  } else {
    // Ref: https://github.com/boto/boto3/issues/1824.
    headers['x-amz-storage-class'] = AWS_S3_STORAGE_CLASS;
  }

  return headers;
};
